import _isNumber from 'lodash/isNumber';

import ActionTypes from '../constants/ActionTypes';
import {
  PROCTOR_SIGNED_URL_LOCALSTORAGE_KEY,
  PROCTOR_NEXT_IMAGE_SEQUENCE_LOCALSTORAGE_KEY,
} from '../constants/Proctor';
import initialState from '../store/initialState';
import { captureException } from '../utils/sentry';

export default (state = initialState.proctor, action) => {
  switch (action.type) {
    case ActionTypes.ENABLE_WEBCAM:
      return {
        ...state,
        webcamEnabled: true,
      };
    case ActionTypes.DISABLE_WEBCAM:
      return {
        ...state,
        webcamEnabled: false,
      };
    case `${ActionTypes.UPLOAD_IDENTITY_IMAGE}_SUCCESS`: {
      return {
        ...state,
        isIdentityImageUploaded: true,
      };
    }
    case `${ActionTypes.UPLOAD_IDENTITY_IMAGE}_FAIL`: {
      return {
        ...state,
        isIdentityImageUploaded: false,
      };
    }
    case `${ActionTypes.HAS_IDENTITY_IMAGE}_SUCCESS`: {
      return {
        ...state,
        hasIdentityImage: true,
      };
    }
    case `${ActionTypes.HAS_IDENTITY_IMAGE}_FAIL`: {
      return {
        ...state,
        hasIdentityImage: false,
      };
    }
    case ActionTypes.VERIFYING_IDENTITY_IMAGE: {
      return {
        ...state,
        isIdentityImageVerifying: true,
      };
    }
    case `${ActionTypes.VERIFYING_IDENTITY_IMAGE}_SUCCESS`: {
      return {
        ...state,
        isIdentityImageVerifying: null,
        identityImageErrMessage: null,
      };
    }
    case `${ActionTypes.VERIFYING_IDENTITY_IMAGE}_FAIL`: {
      return {
        ...state,
        isIdentityImageVerifying: null,
      };
    }
    case `${ActionTypes.VERIFYING_IDENTITY_IMAGE}_ERROR`: {
      return {
        ...state,
        identityImageErrMessage: action.payload,
      };
    }
    case `${ActionTypes.GET_IDENTITY_DEATILS}_SUCCESS`: {
      return {
        ...state,
        hasIdentityImage: !!action.payload.identityImageUrl,
        hasIdProofImage: !!action.payload.idProofImageUrl,
        hasAudioSample: !!action.payload.audioSampleUrl,
        identityImageUrl: action.payload.identityImageUrl,
        idProofImageUrl: action.payload.idProofImageUrl,
        audioSampleUrl: action.payload.audioSampleUrl,
      };
    }
    case `${ActionTypes.GET_IDENTITY_DEATILS}_FAIL`: {
      return {
        ...state,
        hasIdentityImage: false,
        hasIdProofImage: false,
        hasAudioSample: false,
        identityImageUrl: null,
        idProofImageUrl: null,
        audioSampleUrl: null,
      };
    }
    case `${ActionTypes.UPLOAD_IDPROOF_IMAGE}_SUCCESS`: {
      return {
        ...state,
        isIdProofImageUploaded: true,
      };
    }
    case `${ActionTypes.UPLOAD_IDPROOF_IMAGE}_FAIL`: {
      return {
        ...state,
        isIdProofImageUploaded: false,
      };
    }
    case ActionTypes.UPLOAD_AUDIO_SAMPLE: {
      return {
        ...state,
        isSampleAudioUploadInProgress: true,
      };
    }
    case `${ActionTypes.UPLOAD_AUDIO_SAMPLE}_SUCCESS`: {
      return {
        ...state,
        isSampleAudioUploadInProgress: false,
        hasAudioSample: true,
      };
    }
    case `${ActionTypes.UPLOAD_AUDIO_SAMPLE}_FAIL`: {
      return {
        ...state,
        isSampleAudioUploadInProgress: false,
      };
    }
    case ActionTypes.RETAKE_AUDIO_SAMPLE: {
      return {
        ...state,
        hasAudioSample: false,
      };
    }
    case `${ActionTypes.HAS_IDPROOF_IMAGE}_SUCCESS`: {
      return {
        ...state,
        hasIdProofImage: true,
        idProofImageUrl: action.payload.idProofImageUrl,
      };
    }
    case `${ActionTypes.HAS_IDPROOF_IMAGE}_FAIL`: {
      return {
        ...state,
        hasIdProofImage: false,
        idProofImageUrl: '',
      };
    }
    case ActionTypes.VERIFYING_IDPROOF_IMAGE: {
      return {
        ...state,
        isIdProofImageVerifying: true,
      };
    }
    case `${ActionTypes.VERIFYING_IDPROOF_IMAGE}_SUCCESS`: {
      return {
        ...state,
        isIdProofImageVerifying: null,
        idProofImageErrMessage: null,
      };
    }
    case `${ActionTypes.VERIFYING_IDPROOF_IMAGE}_FAIL`: {
      return {
        ...state,
        isIdProofImageVerifying: null,
      };
    }
    case `${ActionTypes.VERIFYING_IDPROOF_IMAGE}_ERROR`: {
      return {
        ...state,
        idProofImageErrMessage: action.payload,
      };
    }
    case ActionTypes.RETAKE_IDPROOF_SNAPSHOT: {
      return {
        ...state,
        hasIdProofImage: false,
        isIdProofImageUploaded: false,
      };
    }
    case ActionTypes.ALLOW_WEBCAM_PERMISSION:
      return {
        ...state,
        webcamPermission: true,
      };
    case ActionTypes.DENY_WEBCAM_PERMISSION:
      return {
        ...state,
        webcamPermission: false,
      };
    case ActionTypes.ALLOW_MIC_PERMISSION:
      return {
        ...state,
        audioPermission: true,
      };
    case ActionTypes.DENY_MIC_PERMISSION:
      return {
        ...state,
        audioPermission: false,
      };
    case ActionTypes.MIC_PERMISSION_LOADING:
      return {
        ...state,
        audioPermissionLoading: action.payload || false,
      };
    case ActionTypes.WEBCAM_PERMISSION_LOADING:
      return {
        ...state,
        webcamPermissionLoading: action.payload || false,
      };
    case ActionTypes.ENABLE_SNAPSHOT_INTERVAL:
      return {
        ...state,
        snapshotInterval: action.payload,
      };
    case ActionTypes.DISABLE_SNAPSHOT_INTERVAL:
      return {
        ...state,
        snapshotInterval: null,
      };
    case ActionTypes.ENABLE_FULLSCREEN:
      return {
        ...state,
        fullScreenEnabled: true,
      };
    case ActionTypes.DISABLE_FULLSCREEN:
      return {
        ...state,
        fullScreenEnabled: false,
      };
    case ActionTypes.ENABLE_VISIBILITY:
      return {
        ...state,
        visibilityEnabled: true,
      };
    case ActionTypes.DISABLE_VISIBILITY:
      return {
        ...state,
        visibilityEnabled: false,
      };
    case ActionTypes.INITILIZE_BROWSER_TOLERANCE: {
      try {
        const key = `DoSelect.tc${action.testSlug}`;
        const fromStorage = localStorage.getItem(key);
        let initialValue = _isNumber(action.count) ? action.count : 0;
        if (fromStorage) initialValue = parseInt(window.atob(fromStorage), 10);
        else if (_isNumber(initialValue))
          localStorage.setItem(key, window.btoa(initialValue));
        return {
          ...state,
          browserToleranceCount: initialValue,
        };
      } catch (localStorageError) {
        captureException(localStorageError);
        return state;
      }
    }
    case ActionTypes.SHOW_BROWSER_TOLERANCE_MODAL:
      return {
        ...state,
        showBrowserTolerance: true,
      };
    case ActionTypes.HIDE_BROWSER_TOLERANCE_MODAL:
      return {
        ...state,
        showBrowserTolerance: false,
      };
    case ActionTypes.DECREMENT_BROWSER_TOLERANCE_COUNT: {
      try {
        const key = `DoSelect.tc${action.testSlug}`;
        const browserToleranceCount =
          action?.count || state.browserToleranceCount - 1;
        localStorage.setItem(key, window.btoa(browserToleranceCount));
        return {
          ...state,
          browserToleranceCount,
        };
      } catch (localStorageError) {
        captureException(localStorageError);
        return state;
      }
    }
    case ActionTypes.SET_WEBCAM_EXCEPTION: {
      return {
        ...state,
        webcamException: action.payload,
      };
    }
    case ActionTypes.SET_PROCTORING_AB_ENABLED:
      return {
        ...state,
        isProctoringABEnabled: action.isEnabled,
      };
    case ActionTypes.SET_PROCTOR_BATCH_AB_ENABLED:
      return {
        ...state,
        isProctorBatchABEnabled: action.isEnabled,
      };
    case `${ActionTypes.UPDATE_PROCTORING_SIGNED_URLS}_FROM_CACHE`: {
      return {
        ...state,
        proctoringSignedUrls: action.updatedSignedUrls,
      };
    }
    case `${ActionTypes.UPDATE_PROCTORING_SIGNED_URLS}_INITIATED`: {
      return {
        ...state,
        fetchingSignedUrls: true,
      };
    }
    case `${ActionTypes.UPDATE_PROCTORING_SIGNED_URLS}_SUCCESS`: {
      const { signedUrls } = action;
      const updatedSignedUrls = {
        ...signedUrls,
        ...state.proctoringSignedUrls,
      };
      localStorage.setItem(
        PROCTOR_SIGNED_URL_LOCALSTORAGE_KEY,
        JSON.stringify(updatedSignedUrls)
      );
      return {
        ...state,
        fetchingSignedUrls: false,
        proctoringSignedUrls: updatedSignedUrls,
      };
    }
    case `${ActionTypes.UPDATE_PROCTORING_SIGNED_URLS}_FAIL`: {
      return {
        ...state,
        fetchingSignedUrls: false,
      };
    }
    case ActionTypes.REMOVE_PROCTORING_SIGNED_URL: {
      const { imageSequence } = action;
      const signedUrls = { ...state.proctoringSignedUrls };

      Object.keys(signedUrls).forEach(signedUrlKey => {
        if (
          typeof signedUrlKey === 'string' &&
          typeof imageSequence === 'string' &&
          parseFloat(signedUrlKey) < parseFloat(imageSequence)
        ) {
          delete signedUrls[signedUrlKey];
        }
      });

      localStorage.setItem(
        PROCTOR_SIGNED_URL_LOCALSTORAGE_KEY,
        JSON.stringify({ ...signedUrls })
      );
      return {
        ...state,
        proctoringSignedUrls: { ...signedUrls },
      };
    }
    case ActionTypes.UPDATE_SIGNED_URL_BATCH_SIZE: {
      return {
        ...state,
        signedUrlBatchSize: action.batchSize,
      };
    }
    case ActionTypes.SET_REALTIME_PROCTORING_FEEDBACK_ENABLED: {
      return {
        ...state,
        isRealtimeFeedbackEnabled: action.payload,
      };
    }
    case ActionTypes.SET_NEXT_PROCTOR_IMAGE_SEQUENCE: {
      const nextProctorImageSequence = action.payload;
      sessionStorage.setItem(
        PROCTOR_NEXT_IMAGE_SEQUENCE_LOCALSTORAGE_KEY,
        nextProctorImageSequence
      );
      return {
        ...state,
        nextProctorImageSequence: nextProctorImageSequence || -1,
      };
    }
    case ActionTypes.SET_PROCTOR_SESSION_ID: {
      return {
        ...state,
        proctorSessionId: action.payload,
      };
    }
    case ActionTypes.SET_PROCTOR_TAB_ID: {
      return {
        ...state,
        proctorTabId: action.payload,
      };
    }
    case ActionTypes.EVALUATE_WEBSOCKET_BROWSER_TOLERANCE_COUNT: {
      try {
        const browserToleranceCount = action.count;
        if (browserToleranceCount < state.browserToleranceCount) {
          const key = `DoSelect.tc${action.testSlug}`;
          localStorage.setItem(key, window.btoa(browserToleranceCount));
          return {
            ...state,
            browserToleranceCount,
          };
        }
        return state;
      } catch (localStorageError) {
        captureException(localStorageError);
        return state;
      }
    }
    case ActionTypes.LEAVE_TEST_VIOLATION: {
      return {
        ...state,
        leaveTestViolation: action.payload,
      };
    }
    case ActionTypes.MULTI_SESSION_ACTIVE: {
      return {
        ...state,
        multiSession: true,
      };
    }
    case ActionTypes.SECURE_BROWSER_SYSTEM_CHECK: {
      return {
        ...state,
        secureBrowserMeta: {
          systemCheck: {
            ...state.secureBrowserMeta.systemCheck,
            ...action.payload,
          },
          reverify: state.secureBrowserMeta.reverify,
        },
      };
    }
    case ActionTypes.RECHECK_SYSTEM_REQ: {
      return {
        ...state,
        secureBrowserMeta: {
          systemCheck: {
            ...state.secureBrowserMeta.systemCheck,
          },
          reverify: !state.secureBrowserMeta.reverify,
        },
      };
    }
    case ActionTypes.SET_VAD_BLOCKING_PROBLEM_TYPE: {
      return {
        ...state,
        vadBlockingProblemType: action.payload,
      };
    }
    case ActionTypes.INCREMENT_WEBCAM_RENDER_KEY: {
      return {
        ...state,
        webcamRenderKey: state.webcamRenderKey + 1,
      };
    }

    default:
      return state;
  }
};
